import { atom } from 'jotai';
import { atomFamily } from 'jotai/utils';
import mobileDetect from '@utils/misc/mobileDetect';
import { TOOLS } from '../control-panel/Toolbar';
import { get as loGet } from 'lodash';
const isMobile = mobileDetect();

export enum Tabs {
  MetricCharts,
  Widgets,
}

/// TODO: move to another file
// layout configurations and state
export const HZ_LAYOUT_PREFIX = '4';
const DIAG_MODE_LAYOUT = '4d';

export const PANEL_SIZE_MAPPING = {
  1: { width: '30%' },
  2: { width: '100%' },
  3: { width: '150%' },
  [HZ_LAYOUT_PREFIX]: { width: '100%' }, // layout switch
};

export const CHART_SIZE_MAPPING = {
  s: { length: '380px', height: '180px' },
  m: { length: '45%', height: '220px' },
  l: { length: '100%', height: '300px' },
  d: { length: '100%', height: '450px' },
};

const layoutAtom = atom('4s');

const percentileAtom = atom('avg');

const widgetPanelVisibilityAtom = atom(false);

const horizontalLayoutAtom = atom((get) => {
  const diagMode = get(diagnosticsModeAtom);
  const layout = diagMode ? DIAG_MODE_LAYOUT : get(layoutAtom);
  return layout.startsWith(HZ_LAYOUT_PREFIX);
});

const panelStyleAtom = atom((get) => {
  const diagMode = get(diagnosticsModeAtom);
  const layout = diagMode ? DIAG_MODE_LAYOUT : get(layoutAtom);
  const [level, chartSize] = layout.split('');
  const panelLevel = Number(level);
  return {
    panelWidth: loGet(PANEL_SIZE_MAPPING, [panelLevel, 'width'], '100%'),
    chartSize: loGet(CHART_SIZE_MAPPING, [chartSize], CHART_SIZE_MAPPING.s),
    panelLevel,
  };
});

const sliceAreaAtom = atom(null);
const zoomAreaAtom = atom(null);
const unitAtom = atom('%');
const activeTabAtom = atom(Tabs.MetricCharts);

const isMetricTabActiveAtom = atom((get) => {
  const currentTab = get(activeTabAtom);
  return currentTab === Tabs.MetricCharts;
});

const isWidgetTabActiveAtom = atom((get) => {
  const currentTab = get(activeTabAtom);
  return currentTab === Tabs.Widgets;
});

const diagnosticsModeAtom = atom(false);
const yScaleModeAtom = atom(false);
const dodAtom = atom(false);
const logAxisAtom = atom(false);
const activeToolAtom = atom(isMobile ? TOOLS.noTool : TOOLS.select);
const errorResponseAtom = atom({});
const errorDataAtom = atom({
  shouldBeReset: false,
  fields: [] as string[],
  filters: [] as string[],
});
const unsupportedMetricsAtom = atom<{ metrics: string[]; cause: string }>({
  metrics: [],
  cause: '',
});
// query metrics
const queryMetricsAtom: any = atom([]);

// atom family to manage all metric data flows
const metricPanelDataAtomFamily = atomFamily(
  ({ tag, defaultValue = null }: any) => {
    return atom(defaultValue);
  },
  (a, b) => {
    return a.tag === b.tag;
  },
);

const primaryFilterVisibilityAtom = atom(true);

const metricPanelShareAtom = atom((get) => {
  return {
    sliceArea: get(sliceAreaAtom),
    zoomArea: get(zoomAreaAtom),
    unit: get(unitAtom),
    layout: get(layoutAtom),
    diagnosticsMode: get(diagnosticsModeAtom),
    yScaleMode: get(yScaleModeAtom),
    logAxis: get(logAxisAtom),
    widgetPanelVisibility: get(widgetPanelVisibilityAtom),
    primaryFilterVisibility: get(primaryFilterVisibilityAtom),
    activeTab: get(activeTabAtom),
    percentile: get(percentileAtom),
  };
});

const metricPanelPersistenceAtom = atom((get) => {
  return {
    layout: get(layoutAtom),
    activeTab: get(activeTabAtom),
    widgetPanelVisibility: get(widgetPanelVisibilityAtom),
    percentile: get(percentileAtom),
    yScaleMode: get(yScaleModeAtom),
  };
});

const panelLoadingStateAtom = atom(false);

export {
  sliceAreaAtom,
  zoomAreaAtom,
  unitAtom,
  percentileAtom,
  layoutAtom,
  horizontalLayoutAtom,
  metricPanelShareAtom,
  diagnosticsModeAtom,
  dodAtom,
  yScaleModeAtom,
  queryMetricsAtom,
  metricPanelDataAtomFamily,
  logAxisAtom,
  errorResponseAtom,
  errorDataAtom,
  unsupportedMetricsAtom,
  primaryFilterVisibilityAtom,
  activeToolAtom,
  panelStyleAtom,
  activeTabAtom,
  isMetricTabActiveAtom,
  metricPanelPersistenceAtom,
  widgetPanelVisibilityAtom,
  panelLoadingStateAtom,
  isWidgetTabActiveAtom,
};
